<template>

<div class="container">
    <div class="top">
      <div  class="fanhui" v-if="isShowBack">
        <img src="../../../static/images/other-fanhui.png" @click="goBack" >
      </div>
			<!-- <div v-if="false" @click="gotoyijianfankuipage" class="fankui">反馈</div> -->
		</div>
    <img src="../../../static/images/vip_other.png" />
</div>
</template>

<script>
// import axios from 'axios';
// import {
//     getToken,
//     setToken,
//     setUserId,
//     setAppId,
//     setIsPay,
//     getLicenceid,
//     setLicenceid
// } from "@/utils/auth";
// import { login } from "@/api/user";

import { checkSign } from "@/api/verify";
export default {
  name: "paid",
  components: {
    // LearnTime
  },
  data() {
    return {
      show: false,
      showType: 1,
      ke1: 0,
      ke4: 0,
      isShowBack: false
    };
  },
  created() {
    if (this.GetRequest('channel') == 'exejH5') {
      this.isShowBack = true
    }
	//   let appver = this.GetRequest('appver') ? this.GetRequest('appver') : ''
    // let channel = this.GetRequest('channel') ? this.GetRequest('channel') : ''
    // let os = this.GetRequest('os') ? this.GetRequest('os') : ''
    // let sign = this.checkSing.checkMd5(this.GetRequest('appid')+appver+channel+this.GetRequest('cx')+this.GetRequest('km')+os+this.GetRequest('timestamp') + this.GetRequest('userid'))
    // if( this.GetRequest('appid') && this.GetRequest('cx') && this.GetRequest('km') && this.GetRequest('userid') && this.GetRequest('timestamp') && this.GetRequest('sign') && sign == this.GetRequest('sign')){

    // }else{
    //   this.$router.push({
    //     name: "error",
    //     params: { name: "item", id: 1 }
    //   });
    // }
	// checkSign({
  //       data_string : window.location.hash
  //   },({data})=>{
  //     console.log(11111111111111111)
  //     console.log(data)
  //     if(data.code != 0){
  //       this.$router.push({
  //         name: "error",
  //         params: { name: "item", id: 1 }
  //       });
  //     }
  //   })
    document.documentElement.style.fontSize = "625%";

  },
  mounted() {
  },
  methods: {
    //返回
    goBack() {
      this.$router.go(-1);
    },
  }
};
</script>

<style lang="scss" scoped>
html {
  background-color: #fff;
}
</style>
<style lang="scss">
html {
  font-size: 625%;
  width: 100%;
}
.container {
  width: 100%;
  font-size: 0.18rem;
  img{
      width: 100vw;
  }
  .top {
		display: flex;
		justify-content: space-between;
		padding: 0 5%;
		width: 90%;
    height: 11vw;
    align-items: center;
    background: #fff;
		.fanhui {
			width: 0.07rem;
			height: 0.13rem;
			img {
				width: 100%;
				height: 100%;
			}
		}
		.fankui {
			margin-top: 0.1rem;
			font-size: 0.15rem;
			letter-spacing: 0.01rem;
		}
		.tab {
			margin-top: 0.05rem;
			font-size: 0.16rem;
			display: flex;
			font-size: 0.16rem;
			height: 0.29rem;
			line-height: 0.29rem;
			div {
				padding-left: 0.1rem;
				padding-right: 0.1rem;
				color: #333333;
			}
			div:nth-child(1) {
				border-radius: 3px 0 0 3px;
			}
			div:nth-child(2) {
				border-radius: 0px 3px 3px 0px;
			}
			.select {
				color: #ffffff;
				background-color: #0090ff;
			}
		}
	}
}
</style>
